<template>
  <v-autocomplete
    :value="value"
    :items="items"
    item-text="name"
    item-value="id"
    :label="label"
    :filter="filterItem"
    outlined
    :disabled="disabled"
    :loading="loading"
    @input="$emit('input', $event)"
  >
    <template v-slot:selection="{ item }">
      <v-chip class="technical-card-select__chip">
        <span class="technical-card-select__id">#{{ item.id }}</span>
        {{ item.name }}
        <a
          :href="editHref(item)"
          target="_blank"
          rel="noopener"
          class="technical-card-select__edit"
          title="Открыть техкарту в новой вкладке"
          @click.stop
          @mousedown.stop
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </a>
      </v-chip>
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-content>
          <v-list-item-title>
            <span class="technical-card-select__id">#{{ item.id }}</span>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
  /**
   * Выбор техкарты блюда. В списке и в чипсе id перед названием, поиск по id или названию.
   * В чипсе карандаш, открывающий редактирование техкарты в новой вкладке.
   */
  export default {
    name: 'TechnicalCardSelect',
    props: {
      value: {
        type: [Number, String],
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: 'Техническая карта',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      filterItem (item, queryText) {
        const query = (queryText || '').trim().toLowerCase().replace(/^#/, '')

        if (!query) return true

        if (/^\d+$/.test(query)) {
          return String(item.id).startsWith(query)
        }

        return (item.name || '').toLowerCase().includes(query)
      },
      editHref (item) {
        return this.$router.resolve({ path: `/technicalcards/${item.id}` }).href
      },
    },
  }
</script>

<style scoped lang="less">
.technical-card-select {
  &__id {
    margin-right: 6px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }
  &__edit {
    display: inline-flex;
    margin-left: 12px;
    color: inherit;
    text-decoration: none;
    opacity: 0.6;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
